module.exports = __webpack_public_path__ + "assets/97967d42f8760bdd7a07c527ceccb79e.png";